import React, {useEffect, useState} from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import {getWorkHours} from '../../components/common';
import { useRestaurant } from '../../contexts/restaurant.context';
import { sidebars } from '../../store/actions/sidebar.actions';

function SideVendor() {
    const [today, setToday] = useState(null);

    const restaurant = useRestaurant();
    const activeSidebar = useSelector((state) => state.sidebar.active);

    useEffect(() => {
        setToday(getWorkHours(restaurant));
    }, [restaurant]);

    if (!restaurant) {
        return null;
    }

    return (
        <div id="sideVendor" className={classNames('col sidebar as-shadow vendor-sidebar d-md-none pb-2 pb-md-0', {show: activeSidebar === sidebars.schedule})}>

            <div className="vendor-details">
                {/*<h2 className="title">Schedule</h2>*/}
                <h5>{restaurant.name}</h5>
                {restaurant.address && (<h5>{restaurant.address}</h5>)}
                {restaurant.phone && (<h5>{restaurant.phone}</h5>)}
                {restaurant.website && (<a href={restaurant.website} target={'_blank'}>{restaurant.website}</a>)}
                <hr/>

                <div className="row">
                    <div className="col-6">
                        <h5>Today</h5>
                    </div>
                    <div className="col-6 text-right">
                        <h5 className="open-status">{today ? 'Open Now' : 'Closed Now'}</h5>
                    </div>
                </div>

                {today && (
                    <div className="row">
                        <div className="col-3">
                            <h6>Hours</h6>
                        </div>
                        <div className="col-9 text-right">
                            {(+today.endHour - +today.beginHour) === 24 ? (
                                <h6>24 hrs</h6>
                            ) : (
                                <h6>{`${today.begin} - ${today.end}`}</h6>
                            )}
                        </div>
                    </div>
                )}

                <div className="row mt-4">
                    <div className="col-12">
                        <h5>Full Schedule</h5>
                        <ul className="business-hours">
                            {restaurant.business_hours.map(business_hour => (
                                <li>
                                    <div>{business_hour.dayFull}</div>
                                    {/*<div className="text-center text-muted font-weight-bold">Closed</div>*/}
                                    {(+business_hour.endHour - +business_hour.beginHour) === 24 ? (
                                        <div className="text-right">24 hrs</div>
                                    ) : (
                                        <div className="text-right">{`${business_hour.begin} - ${business_hour.end}`}</div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default SideVendor;